import { render, staticRenderFns } from "./BlvckTopupTransactions.vue?vue&type=template&id=4554f5cc"
import script from "./BlvckTopupTransactions.vue?vue&type=script&lang=js"
export * from "./BlvckTopupTransactions.vue?vue&type=script&lang=js"
import style0 from "./BlvckTopupTransactions.vue?vue&type=style&index=0&id=4554f5cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports